import { Euler, Matrix4, Quaternion, Vector3 } from 'three'

const quat = new Quaternion()
export default function toQuaternion(
  quatParams?:
    | Euler
    | [Vector3, number]
    | Matrix4
    | [Vector3, Vector3]
    | Quaternion
    | [number, number, number, number],
) {
  if (!quatParams) return quat.clone()
  const isArray = Array.isArray(quatParams)
  if (isArray && quatParams.length === 4) return quat.clone().fromArray(quatParams)
  if (quatParams instanceof Matrix4) return quat.clone().setFromRotationMatrix(quatParams)
  if (quatParams instanceof Quaternion) return quat.clone().copy(quatParams)
  if (isArray && quatParams.length === 2) {
    if (quatParams[1] instanceof Vector3)
      return quat.clone().setFromUnitVectors(quatParams[0], quatParams[1])
    quat.clone().setFromAxisAngle(quatParams[0], quatParams[1])
  }
  if (quatParams instanceof Euler) return quat.clone().setFromEuler(quatParams)
  return quat.clone()
}
